import { config } from 'config';

// Generate a number from a string (ie. to choose a color)
function generateNumber(id: string) {
  if (!id) return null;

  for (let i = id.length - 1; i >= 0; i--) {
    const char = id[i].toLowerCase();
    if (Number.parseInt(char) >= 0 && Number.parseInt(char) <= 9) {
      return Number.parseInt(char) % 10;
    }
    if (char >= 'a' && char <= 'z') {
      return (char.charCodeAt(0) - 'a'.charCodeAt(0)) % 10;
    }
  }
  return null;
}

// Get a color class based on an id
export const numberToColorClass = (id?: string) => {
  if (!id) return 'bg-gray-300';
  const index = generateNumber(id) || 0;
  return config.placeholderColors[index];
};
